import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import LanguageMultiChoice from '../BaseInputs/Selectors/MultiChoice/LanguageMultiChoice';
import OfficeMultiChoice from '../BaseInputs/Selectors/MultiChoice/OfficeMultiChoice';
import OfficeForReportMultiSelect from '../BaseInputs/Selectors/MultiChoice/OfficeForReportMultiSelect';
import OfficeGroupMultiSelect from '../BaseInputs/Selectors/MultiChoice/OfficeGroupMultiSelect';
import TpJobThirdPartyStatusMultiSelect from '../BaseInputs/Selectors/MultiChoice/TpJobThirdPartyStatusMultiSelect';
import TpJobStatusMultiSelect from '../BaseInputs/Selectors/MultiChoice/TpJobStatusMultiSelect';
import ClientMultiChoice from '../BaseInputs/Selectors/MultiChoice/ClientMultiChoice';
import ClientMultiChoiceAll from '../BaseInputs/Selectors/MultiChoice/ClientMultiChoiceAll';
import CountryMultiChoice from '../BaseInputs/Selectors/MultiChoice/CountryMultiChoice';
import ThirdPartySourceMultiChoice from '../BaseInputs/Selectors/MultiChoice/ThirdPartySourceMultiChoice';
import PlatformMultiChoice from '../BaseInputs/Selectors/MultiChoice/PlatformMultiChoice';
import ActiveGroupMultiChoice from '../BaseInputs/Selectors/MultiChoice/ActiveGroupMultiChoice';
import MultiChoice from '../BaseInputs/Selectors/MultiChoice/MultiChoice';
import DataFlowMapMultiChoice from '../BaseInputs/Selectors/MultiChoice/DataFlowMapMultiChoice';
import FreelancerDepartmentMultiChoice from '../BaseInputs/Selectors/MultiChoice/FreelancerDepartmentMultiChoice';
import ServiceMultiChoice from '../BaseInputs/Selectors/MultiChoice/ServiceMultiChoice';
import ServiceCountryMultiSelect from '../BaseInputs/Selectors/MultiChoice/ServiceCountryMultiSelect';
import ContactMultiChoice from '../BaseInputs/Selectors/MultiChoice/ContactMultiChoice';
import OpportunityMultiChoice from '../BaseInputs/Selectors/MultiChoice/OpportunityMultiChoice';
import CommissionUserMultiChoice from '../BaseInputs/Selectors/MultiChoice/CommissionUserMultiChoice';
import UserMultiChoice from '../BaseInputs/Selectors/MultiChoice/UserMultiChoice';
import CaspianRolesMultiCheck from '../BaseInputs/Selectors/CaspianRolesMultiCheck';
import TimesheetUserListSelect from '../BaseInputs/Selectors/TimesheetUserListSelect';
import SurveyMultiChoice from '../BaseInputs/Selectors/MultiChoice/SurveyMultiChoice';
import TpSurveyMultiChoice from '../BaseInputs/Selectors/MultiChoice/TpSurveyMultiChoice';

export const renderLanguageMultiSelectField = (props) => (
  <LanguageMultiChoice
    selected={props.value}
    fieldName={props.fieldName}
    onChange={(value) => props.onChange(props.fieldName, value)}
  />
);

export const renderOfficeMultiSelectField = (props) => (
  <OfficeMultiChoice
    selected={props.value}
    fieldName={props.fieldName}
    onChange={(value) => props.onChange(props.fieldName, value)}
  />
);

export const renderOfficeForReportMultiSelectField = (props) => (
  // todo: if props.placeholder === 'select_all', select all offices by default, but allow modification
  <OfficeForReportMultiSelect
    selected={props.value}
    onChange={(value) => props.onChange(props.fieldName, value)}
    placeholder={props.placeholder}
  />
);

export const renderOfficeGroupMultiSelectField = (props) => (
  <OfficeGroupMultiSelect
    selected={props.value}
    onChange={(value) => props.onChange(props.fieldName, value)}
  />
);

export const renderTpJobThirdPartyStatusMultiSelectField = (props) => (
  <TpJobThirdPartyStatusMultiSelect
    selected={props.value}
    fieldName={props.fieldName}
    onChange={(value) => props.onChange(props.fieldName, value)}
  />
);

export const renderTpJobStatusMultiSelectField = (props) => (
  <TpJobStatusMultiSelect
    selected={props.value}
    fieldName={props.fieldName}
    onChange={(value) => props.onChange(props.fieldName, value)}
  />
);

export const renderClientMultiChoice = (props) => (
  <ClientMultiChoice
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    fieldName={props.fieldName}
    label={props.labelText}
  />
);

export const renderClientMultiChoiceAll = (props) => (
  <ClientMultiChoiceAll
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    fieldName={props.fieldName}
    label={props.labelText}
  />
);

export const renderThirdPartySourceMultiChoice = (props) => (
  <ThirdPartySourceMultiChoice
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    fieldName={props.fieldName}
    label={props.labelText}
  />
);

export const renderPlatformMultiChoice = (props) => (
  <PlatformMultiChoice
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    fieldName={props.fieldName}
    label={props.labelText}
  />
);

export const renderThirdPartySourceEvaluatorMultiChoice = (props) => (
  <ThirdPartySourceMultiChoice
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    fieldName={props.fieldName}
    label={props.labelText}
    forEvaluator={true}
  />
);

export const renderThirdPartySourceTpJobMultiChoice = (props) => (
  <ThirdPartySourceMultiChoice
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    fieldName={props.fieldName}
    label={props.labelText}
    forTpJobSearch={true}
  />
);

export const renderActiveGroupMultiChoice = (props) => (
  <ActiveGroupMultiChoice
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    fieldName={props.fieldName}
    label={props.labelText}
  />
);

export const renderCountryMultiChoice = (props) => (
  <CountryMultiChoice
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    fieldName={props.fieldName}
    useCountryCode={props.type === InputTypesEnum.CountryCodeMultiChoice}
    useCountryName={props.type === InputTypesEnum.CountryNameMultiChoice}
  />
);

export const renderMultiChoice = (props) => (
  <MultiChoice
    className={props.className}
    label={props.labelText}
    options={props.selectValues}
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
  />
);

export const renderDataFlowMapMultiChoice = (props) => (
  <DataFlowMapMultiChoice
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
  />
);

export const renderFreelancerDepartmentMultiChoice = (props) => (
  <FreelancerDepartmentMultiChoice
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    showSelectFilterAt={props.showSelectFilterAt}
    selected={props.value}
  />
);

export const renderServiceMultiChoice = (props) => (
  <ServiceMultiChoice
    selected={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderServiceCountryMultiSelect = (props) => (
  <ServiceCountryMultiSelect
    selected={props.value}
    fieldName={props.fieldName}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    idFilter={props.idFilter}
  />
);

export const renderContactMultiChoice = (props) => (
  <ContactMultiChoice
    selected={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderOpportunityMultiChoice = (props) => (
  <OpportunityMultiChoice
    selected={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderCommissionUserMultiChoice = (props) => (
  <CommissionUserMultiChoice
    selected={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderUserMultiSelect = (props) => (
  <UserMultiChoice
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    showSelectFilterAt={props.showSelectFilterAt}
    selected={props.value}
    active={props.type === InputTypesEnum.ActiveUserMultiSelect}
  />
);

export const renderCaspianRolesMultiCheck = (props) => (
  <CaspianRolesMultiCheck
    selected={props.editedItem}
    fieldName={props.fieldName}
    onChange={(value) => props.onChange(props.fieldName, value)}
  />
);

export const renderTimesheetUserListSelect = (props) => (
  <TimesheetUserListSelect
    selected={props.editedItem}
    fieldName={props.fieldName}
    onChange={(value) => props.onChange(props.fieldName, value)}
  />
);

export const renderSurveyMultiChoice = (props) => (
  <SurveyMultiChoice
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    fieldName={props.fieldName}
    label={props.labelText}
  />
);

export const renderTpSurveyMultiChoice = (props) => (
  <TpSurveyMultiChoice
    selected={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
    fieldName={props.fieldName}
    label={props.labelText}
  />
);
